<!-- Home.vue 首页 -->
<template>
  <div class="home-container">
    <component :is="homeComponent"
               :homeInfo="state.homeInfo"
               :expertConfig="state.expertConfig" />
    <RightFixedPanel />
  </div>
</template>

<script>
import homeType1 from './model/home--type1/index.vue'
import homeType2 from './model/home--type2/index.vue'
import homeType3 from './model/home--type3/index.vue'
import homeType4 from './model/home--type4/index.vue'
import homeType5 from './model/home--type5/index.vue'
import homeType6 from './model/home--type6/index.vue'
import RightFixedPanel from '@/components/RightFixedPanel.vue'
import { getExpertConfig, getHomeData } from '@/api/cache'
import { prefetchImageSearchPage } from '@/utils/imageSearchTransfer'

export default {
  name: 'HomePage',
  components: {
    RightFixedPanel
  },
  data() {
    return {
      state: {
        type: 0, // 从接口/路由获取
        homeInfo: {}, // 首页数据
        expertConfig: {}, // 达人配置
      },
    }
  },

  computed: {
    homeComponent() {
      const map = {
        100: homeType1,
        101: homeType2,
        102: homeType3,
        103: homeType4,
        104: homeType5,
        105: homeType6,
      }
      return map[this.state.type]
    },
  },

  created() {
    this.load()
    this.loadExpertConfig()
  },

  methods: {
    async load() {
      const { data } = await getHomeData()
      sessionStorage.setItem('homeData', JSON.stringify(data))
      this.state.type = data.templateId
      sessionStorage.setItem('templateId', this.state.type)
      sessionStorage.setItem('isSearchByImage', data?.expert?.isSearchByImage)
      if (data?.expert?.isSearchByImage === 'Y') {
        prefetchImageSearchPage()
      }
      this.state.homeInfo = data

      // 处理店铺主题
      if (data.storeTheme) {
        this._processStoreTheme(data.storeTheme)
      } else {
        this._processStoreTheme({})
      }
    },

    // 加载达人、装修主题
    async loadExpertConfig() {
      try {
        const { data } = await getExpertConfig()
        sessionStorage.setItem('expertConfig', JSON.stringify(data))
        // 设置favicon
        document.getElementById('dynamic-favicon').href = data.domainImage
        // 设置标题
        document.title = data.domainTitle

        this.state.expertConfig = data
      } catch (error) {
        // 加载达人配置失败，请联系运营
        console.warn('Failed to load the expert configuration. Please contact the operator', error)
      }
    },

    // 处理主题
    _processStoreTheme(theme) {
      // 更新样式配置
      this.$styleManager.updateStyleConfig({
        primaryColor: theme.themeColor,
        backgroundColor: theme.bgColor,
        textColor: theme.selectFontColor || theme.themeColor,
        linkColor: theme.noselectFontColor,
        buttonColor: theme.themeColor
      })
    },
  },
}
</script>
